import React from 'react';
import { Link } from 'react-router-dom';

interface BreadcrumbItemProps {
  crumb: any;
  index: number;
}
const BreadcrumbItem: React.StatelessComponent<BreadcrumbItemProps> = ({ crumb, index }) => {
  return (
    <li key={`${crumb.name} - ${index}`} className="breadcrumb-item_crumb">
      <Link to={`${crumb.url}`}>{crumb.name}</Link>
    </li>
  );
};

export default BreadcrumbItem;
